<template>
    <div class="custom-modal show-custom-modal" @click="closeModal()">
        <div class="custom-modal-window" @click.stop>

            <div class="btn-close" v-if="fetcher.initialized" :class="{ 'btn-white' : clinic.locations.length > 0 || clinic.portrait }" @click="closeModal()"></div>

            <div class="custom-modal-body">

                <div :class="{ 'd-none' : fetcher.initialized }">
                    <div class="container-fluid">
                        <div class="placeholder-glow w-100">
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 34px;"></span>
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 110px;"></span>
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 110px;"></span>
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 110px;"></span>
                        </div>
                    </div>
                </div>

                <div v-if="fetcher.initialized">

                    <div class="presentation-slider" v-if="clinic.locations.length > 0">

                        <flickity ref="flickity" :options="flickityOptions">

                            <div class="carousel-cell" v-for="image in clinic.locations">
                                <img :src="'/storage/clinic-presentation/'+image.name+'.jpg'">
                            </div>

                        </flickity>

                        <img :src="clinic.portrait.thumb_url" class="portrait" v-if="clinic.portrait" />

                    </div>

                    <div class="presentation-slider" v-if="clinic.locations.length == 0">

                        <div class="carousel-cell">
                            <img src="/images/pt.jpg" loading="lazy" v-if="clinic.checkbox_60min === '1'">
                            <img src="/images/card/clinic-default-cover.jpg" loading="lazy" v-else>
                        </div>

                        <img :src="clinic.portrait.thumb_url" class="portrait" v-if="clinic.portrait" />

                    </div>

                    <div class="container-fluid">

                        <h1 class="mb-2">{{ clinic.card_name_clinic }}</h1>

                        <div class="d-flex align-items-center mb-4" style="font-size: 18px;" v-if="clinic.survey_count > 2 && clinic.show_survey_score === 1">
                            <img src="/images/card/review-heart.svg" style="width: 20px; margin-right: 8px;"> <span style="font-weight:500;" class="text-darker me-1">{{ clinic.survey_score}}</span> <span style="color:#999;"> ({{ clinic.survey_count}} st)</span>
                        </div>

                        <p class="mb-0" style="white-space: pre-wrap;" v-if="clinic.booking_presentation">{{ clinic.booking_presentation }}</p>

                        <div class="mt-8">
                            <h2 class="mb-3 text-darker" v-if="!hasPractitioners">Boka tid</h2>

                            <div class="mb-4" v-if="showCardInactiveMessage == true">

                                <p class="mb-3">Du har inga aktiva klippkort.</p>

                                <router-link class="btn btn-primary" :to="linkTo('/shop')" @click="matomoTrackEvent('Shop', 'Link', 'Clinic')">Köp klippkort</router-link>

                            </div>

                            <div v-if="app_version === 'customer_card' || (app_version === 'company_card' && (subscription_status.status === 'active' || subscription_status.status === 'ending'))">
                                <a class="btn btn-primary btn-sm mb-3 me-3"
                                   target="_blank"
                                   :href="clinic.booking_link"
                                   @click="matomoTrackEvent('Booking', 'Book', 'Boka 25 min')"
                                   v-if="clinic.booking_link && clinic.checkbox_25min === '1' && durations.indexOf(25) !== -1"
                                >
                                    <span v-if="app_version === 'company_card'">Boka tid</span>
                                    <span v-else>Boka 25 min</span>
                                </a>
                                <a class="btn btn-primary btn-sm mb-3 me-3"
                                   target="_blank"
                                   :href="clinic.booking_link_2"
                                   @click="matomoTrackEvent('Booking', 'Book', 'Boka 40 min')"
                                   v-if="clinic.booking_link_2 && clinic.checkbox_40min === '1' && durations.indexOf(40) !== -1"
                                >
                                    <span v-if="app_version === 'company_card'">Boka tid</span>
                                    <span v-else>Boka 40 min</span>
                                </a>
                                <a class="btn btn-primary btn-sm mb-3 me-3"
                                   target="_blank"
                                   :href="clinic.booking_link_3"
                                   @click="matomoTrackEvent('Booking', 'Book', 'Boka 50 min')"
                                   v-if="clinic.booking_link_3 && clinic.checkbox_50min === '1' && durations.indexOf(50) !== -1"
                                >
                                    <span v-if="app_version === 'company_card'">Boka tid</span>
                                    <span v-else>Boka 50 min</span>
                                </a>
                                <a class="btn btn-primary btn-sm mb-3 me-3"
                                   target="_blank"
                                   :href="clinic.booking_link_60"
                                   @click="matomoTrackEvent('Booking', 'Book', 'Boka 60 min')"
                                   v-if="clinic.booking_link_60 && clinic.checkbox_60min === '1' && durations.indexOf(60) !== -1"
                                >
                                    <span>Boka tid</span>
                                </a>

                                <!-- Booking buttons for contact ways, if missing booking system -->
                                <div v-if="showCardInactiveMessage == false">

                                    <a class="btn btn-primary btn-sm mb-3 me-3 ps-3"
                                       :href="bookingSmsText"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka via SMS')"
                                       v-if="clinic.checkbox_show_booking_button_sms === '1' && clinic.public_phone"
                                    >
                                        <img src="/images/card/icon-booking-sms.svg?ver=1" class="btn-icon"><span>Boka via SMS</span>
                                    </a>

                                    <a class="btn btn-primary btn-sm mb-3 me-3 ps-3"
                                       :href="'tel:'+clinic.public_phone"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka via telefon')"
                                       v-if="clinic.checkbox_show_booking_button_phone === '1' && clinic.public_phone"
                                    >
                                        <img src="/images/card/icon-booking-phone.svg?ver=1" class="btn-icon"><span>Boka via telefon</span>
                                    </a>

                                    <a class="btn btn-primary btn-sm mb-3 me-3 ps-3"
                                       :href="bookingMailText"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka via e-post')"
                                       v-if="clinic.checkbox_show_booking_button_email === '1' && clinic.public_email"
                                    >
                                        <img src="/images/card/icon-booking-email.svg" class="btn-icon"><span>Boka via e-post</span>
                                    </a>

                                </div>

                                <div v-if="clinic.checkbox_60min !== '1'">
                                    <div class="pt-2" v-if="!clinic.booking_link && !clinic.booking_link_2 && !clinic.booking_link_3 && !hasPractitioners">
                                        <span>Massören erbjuder följande behandlingslängder:</span>

                                        <div class="mb-4 pt-1">
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_25min === '1'">25 min</span>
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_40min === '1'">40 min</span>
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_50min === '1'">50 min</span>
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_60min === '1'">60 min</span>
                                        </div>
                                    </div>
                                </div>

                                <p v-if="clinic.booking_info && showCardInactiveMessage != true" v-html="clinic.booking_info"></p>

                            </div>

                            <div v-if="app_version === 'company_card'">

                                <div class="button-message" v-if="subscription_status.status === 'ending'">
                                    <div class="arrow"></div>
                                    Boka fram till och med <b>{{ subscription_status.date }}</b>.
                                    Därefter slutar din arbetsgivare ge ersättning för behandlingen.
                                </div>

                                <div class="button-message" v-if="subscription_status.status === 'ended'">
                                    Du kan inte längre boka massage, eftersom din arbetsgivare sagt upp avtalet.
                                </div>

                                <div class="button-message" v-if="subscription_status.status === 'pending'">
                                    Du kan börja boka massage från <b>{{ subscription_status.date }}</b>. Välkommen tillbaka!
                                </div>

                            </div>

                        </div>

                        <div class="mb-6" v-if="hasPractitioners">
                            <div class="border-top py-6 py-sm-8"
                                 :class="{
                                    'border-bottom': (index +1) === clinic.practitioners.length,
                                    'mt-8': index === 0
                                 }"
                                 v-for="(practitioner, index) in clinic.practitioners"
                                 :key="`practitioner${practitioner.id}`"
                            >
                                <div class="row">
                                    <div class="col-8 col-sm-4">
                                        <div class="d-grid gap-4">
                                            <img class="w-100 rounded-3" :src="practitioner.portrait.thumb_url" v-if="practitioner.portrait" />

                                            <a target="_blank" :href="practitioner.booking_link_60" class="btn btn-primary btn-sm" v-if="practitioner.booking_link_60">Boka tid</a>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <h3 class="text-darker">{{ practitioner.name }}</h3>
                                        <p>{{ practitioner.presentation }}</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <p class="mt-2 mb-8" v-if="showCardInactiveMessage != true">
                            <i>
                                Mottagningens egna avbokningsregler gäller.
                            </i>
                        </p>

                        <div class="mb-10" v-if="clinic.booking_instructions">

                            <h2 class="text-darker">Övrig information</h2>
                            <p v-html="clinic.booking_instructions"></p>

                        </div>

                        <div class="mb-10">
                            <h2 class="text-darker">Kontaktuppgifter</h2>
                            <p>
                                {{ clinic.card_name_person }}<br>
                                <span v-if="clinic.public_phone"><a :href="'tel:'+clinic.public_phone">{{ clinic.public_phone }}</a><br></span>
                                <span v-if="clinic.public_email"><a :href="'mailto:'+clinic.public_email">{{ clinic.public_email }}</a></span>
                            </p>
                        </div>

                        <div class="mb-10">
                            <h2 class="text-darker">Adress</h2>
                            <p>
                                <address class="mb-0">
                                    <span v-if="clinic.card_name_clinic">{{ clinic.card_name_clinic }}<br></span>
                                    <span v-if="clinic.address.co">{{ clinic.address.co }},<br></span>
                                    <span v-if="clinic.address.street">{{ clinic.address.street }},<br></span>
                                    <span v-if="clinic.address.city">{{ clinic.address.zip }}</span> <span v-if="clinic.address.city">{{ clinic.address.city }}</span>
                                </address>
                                <a :href="'https://maps.google.com/?q='+mapLinkQuery" class="clinic-map-link" target="_blank">Öppna i Google maps</a><br>
                                <a :href="'https://maps.apple.com/maps?q='+mapLinkQuery" class="clinic-map-link apple" target="_blank">Öppna i Kartor</a>
                            </p>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>

import Flickity from 'vue-flickity'

import modaler from '../../../shared/mixins/modaler'
import poster from '../../../shared/mixins/poster'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    components: {
        Flickity
    },

    mixins: [
        modaler,
        poster,
        fetcher
    ],

    data () {
        return {
            clinic: null,
            durations: [],
            fetcher: {
                autoFill: [
                    'clinic',
                    'durations'
                ]
            },
            clinicMap: {
                map: null,
                markers: []
            },
            flickityOptions: {
                prevNextButtons: false,
                wrapAround: true,
                lazyLoad: true
            }
        }
    },

    mounted () {

    },

    computed: {
        fetcherUrl () {
            return '/clinics/' + this.$route.params.clinic
        },
        bookingLinksVisible () {
            if (!(this.clinic.booking_link && this.clinic.checkbox_25min === '1' && this.durations.indexOf(25) !== -1) && !(this.clinic.booking_link_2 && this.clinic.checkbox_40min === '1' && this.durations.indexOf(40) !== -1) && !(this.clinic.booking_link_3 && this.clinic.checkbox_50min === '1' && this.durations.indexOf(50) !== -1) && !(this.clinic.booking_link_60 && this.clinic.checkbox_60min === '1' && this.durations.indexOf(60) !== -1)) {
                return false
            }
            return true
        },
        showCardInactiveMessage () {
            if (this.app_version === 'customer_card' && (this.durations.indexOf(25) === -1 && this.durations.indexOf(40) === -1 && this.durations.indexOf(50) === -1 && this.durations.indexOf(60) === -1)) {
                return true
            }
            return false
        },
        mapLinkQuery () {
            return this.clinic.address.street + ' ' + this.clinic.address.zip + ' ' + this.clinic.address.city
        },
        singleDurationText () {
            if (this.durations.length == 1) {
                return 'Behandlingslängd ' + this.durations[0] + ' minuter. '
            }
            return ''
        },
        hasPractitioners () {
            return this.clinic.practitioners.length > 0
        },
        bookingMailText () {

            if(this.clinic.checkbox_60min === '1')
            {
                return 'mailto:'+this.clinic.public_email+'?subject=Jag vill boka personlig träning via Hälsoresurs&body=Hej. Jag vill boka personlig träning via Hälsoresurs. När finns det lediga tider? Tack!'
            }

            return 'mailto:'+this.clinic.public_email+'?subject=Jag vill boka massage via Hälsoresurs&body=Hej. Jag vill boka massage via Hälsoresurs. '+this.singleDurationText+'När finns det lediga tider? Tack!'

        },

        bookingSmsText () {

            if(this.clinic.checkbox_60min === '1')
            {
                return 'sms:'+this.clinic.public_phone+'?body=Hej. Jag vill boka personlig träning via Hälsoresurs. När finns det lediga tider? Tack!'
            }

            return 'sms:'+this.clinic.public_phone+'?body=Hej. Jag vill boka massage via Hälsoresurs. '+this.singleDurationText+'När finns det lediga tider? Tack!'

        }
    },

    methods: {

        fetcherSuccess () {

            // this.$nextTick(() => {
            //     // this.createMap()
            //     this.carouselFetched = true
            // })

        },

        closeModal () {
            this.$router.push({ name: this.$route.meta.closeTo })
        }
        /*
        createMap () {
            if (this.clinic.address.coordinates) {
                const coordinates = this.clinic.address.coordinates.split(' ')

                this.clinicMap.map = new google.maps.Map(document.getElementById('modal_clinic_map'), {
                    center: { lat: 57.7093551, lng: 11.9686144 },
                    zoom: 15.88,
                    zoomControl: false,
                    scaleControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false
                })

                const icon = {
                    url: '/images/card/map-pointer.png?upd=2',
                    scaledSize: new google.maps.Size(50, 50),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(40, 25)
                }

                const marker = new google.maps.Marker({
                    position: { lat: parseFloat(coordinates[0]), lng: parseFloat(coordinates[1]) },
                    map: this.clinicMap.map,
                    icon: icon,
                    id: '1'
                })

                this.clinicMap.markers.push(marker)
                this.clinicMap.map.setCenter(this.clinicMap.markers[0].getPosition())

                const listener = this.clinicMap.map.addListener('center_changed', () => {
                    this.matomoTrackEvent('Booking', 'Clinic', 'Map interaction')

                    google.maps.event.removeListener(listener)
                })
            }
        }
        */

    }
}
</script>

<style>

</style>
